import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['trigger', 'content']
  static values = { active: String, disabled: Boolean }

  connect() {
    if (!this.hasActiveValue && this.triggerTargets.length > 0) {
      this.activeValue = this.triggerTargets[0].dataset.value
    }
  }

  show(e) {
    this.activeValue = e.currentTarget.dataset.value
  }

  activeValueChanged(currentValue, previousValue) {
    if (currentValue === '' || currentValue === previousValue) return

    this.contentTargets.forEach((el) => el.classList.add('hidden'))
    this.triggerTargets.forEach((el) => (el.dataset.state = 'inactive'))

    this.activeContentTarget &&
      this.activeContentTarget.classList.remove('hidden')
    this.activeTriggerTarget.dataset.state = 'active'
  }

  get activeTriggerTarget() {
    return this.triggerTargets.find(
      (el) => el.dataset.value === this.activeValue
    )
  }

  get activeContentTarget() {
    return this.contentTargets.find(
      (el) => el.dataset.value === this.activeValue
    )
  }

  disabledValueChanged() {
    this.triggerTargets.forEach((btn) => (btn.disabled = this.disabledValue))
  }
}
